import { render } from "./AppreciationDetail.vue?vue&type=template&id=3970a026"
import script from "./AppreciationDetail.vue?vue&type=script&lang=js"
export * from "./AppreciationDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pip-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__